
import { cImageDlg } from "./ImageDlg";
import { cView } from "./View";
import { cSelection } from "./Selection";
import { cMessage } from "./Message";

import { cRealityData } from "./RealityData";

import { Cloudinary } from "cloudinary-core";
import { cUserManager } from "./UserManager";

const MAX_ZOOM_FAC = 10;

export class cImageApi {
  //private static http = "https://token-issuer-service.herokuapp.com/getImage";
  /* 
    Using npm Package Cloudinary
    Only need to know the cloud-name to configure the object for receiving the images
  */
  public static cloudinaryCore = new Cloudinary({ cloud_name: "itwins-test" });

  public static async fetchImage(fileName: string): Promise<string> {
    const filePrefix = fileName.replace(".jpg", "");
    //console.log(filePrefix);
   // const cloudinaryCore = new Cloudinary({ cloud_name: "itwins-test" });
    const imageData = this.cloudinaryCore.url(`samples/${filePrefix}`); //"samples" is the folder name

    return imageData;
  }
}

export class cImage {
  // private static _image: string;

  public static startPhotoNavigation = () => {
    //    cSelectionPopup.disablePopupToolbar();  //!!OA popup should recognize jpg files
    let rm = cRealityData.getActiveRealityModelName();
    const name = `$Camera-${rm}`;
    cView.setModelVisibility("$Camera", true);
    cSelection.setOnElementSelected("camera", cImage.onCameraSelected);
    cMessage.showStatusBarMessage("Click on a marker to see photograph", "icon-cursor-click");
  }

  public static endPhotoNavigation = () => {
    cView.setModelVisibility("$Camera", false);
    cSelection.setOnElementSelected("camera");
    cMessage.clearStatusBarMessage();
    //    cSelectionPopup.enablePopupToolbar();
  }

  public static onCameraSelected = async(elementIds: string[]) => {

    const image = elementIds[0];
    if (image && image.toLowerCase().includes(".jpg")) {
      cSelection.clearSelection();
      await this.startImageTool(image);
    }
    console.log("onCameraSelected: " + image);
  }

  public static startImageTool = async (imageName: string) => {
    const result = await cImageApi.fetchImage(imageName);
    // .then(() => {
    this.displayImage(result);
    // })
    // .catch(null);
    // cMessage.showStatusBarMessage(`Downloading ${imageName}...`, "icon-cloud-download");
    // await cImageApi.fetchImage(image);
  }

  public static displayImage = (image: string) => {
    if (!cImageDlg.isDialogOpen()) {
      cImageDlg.openDialog(image);
    } else {
      cImageDlg.updateDialog(image);
    }
    cMessage.clearStatusBarMessage();
  }

}

export class cZoom {
  private static _imgX: number;
  private static _imgY: number;
  private static _imgW: number;
  private static _imgH: number;
  private static _imgAspect: number;
  private static _image?: string;
  private static _divHTML?: HTMLElement;
  private static _zoomFactor = 1;
  private static _zoomW: number;
  private static _zoomH: number;
  private static _mouseX: number;
  private static _mouseY: number;
  private static _mouseState = 0; //0: Up, 1: Down, 2: Down+Move

  public static initImage = (image: string, width: number, height: number) => {
    this._image = image;
    this._imgW = width;
    this._imgH = height;
    this._imgAspect = height / width;

    this._divHTML = document.getElementById("zoomDIV")!;
    if (this._divHTML) {
      this.setImageSrc(this._image);
      this.setImageWidth(this._imgW);
      this.setImageXY(0, 0);
    }

    this.setZoomFactor(1);
  }

  public static mouseMove = (ev: MouseEvent) => {
    if (ev.buttons === 1) {
      const x = this._imgX + (ev.clientX - this._mouseX);
      const y = this._imgY + (ev.clientY - this._mouseY);

      this.setImageXY(x, y);

      this._mouseX = ev.clientX;
      this._mouseY = ev.clientY;
    }
    this._mouseState = 2;
  }

  public static mouseDown = (ev: MouseEvent) => {
    if (ev.buttons === 1) {
      this._mouseX = ev.clientX;
      this._mouseY = ev.clientY;
    }
    this._mouseState = 1;
  }

  public static mouseUp = (ev: MouseEvent) => {
    if (this._mouseState === 1) {
      if (this._mouseX === ev.clientX && this._mouseY === ev.clientY) {
        const a = this._divHTML!.getBoundingClientRect();

        const mx = ev.clientX - a.left;
        const my = ev.clientY - a.top;

        this.setZoomFactor(this._zoomFactor * 2);
        this.zoomIn(mx, my);

        this._mouseX = ev.clientX;
        this._mouseY = ev.clientY;
      }
    }
    this._mouseState = 0;
  }

  //  focusX, focusY: focus point on image relative to window origin
  //  focus point is shown in the center of window after zoom
  public static zoomIn = (focusX?: number, focusY?: number) => {
    const a = this._divHTML!.getBoundingClientRect();

    // if focus point is not given, use center of window as focus point
    const px = focusX ?? a.width / 2;
    const py = focusY ?? a.height / 2;

    // location of focus point on the zoomed image
    let mx = -this._imgX + px;
    let my = -this._imgY + py;

    // scale focus point to location on original image
    mx = (mx / this._zoomW) * this._imgW;
    my = (my / this._zoomH) * this._imgH;

    // zoom original image size to new zoom size
    const width = this._imgW * this._zoomFactor;
    const height = width * this._imgAspect;

    // location of focus point in zoomed size
    mx = mx * this._zoomFactor;
    my = my * this._zoomFactor;

    // move image origin such that focus point is in center of window
    const x = -(mx - a.width / 2);
    const y = -(my - a.height / 2);

    this.setImageWidth(width);
    this.setImageXY(x, y);
  }

  public static setImageSrc = (image: string) => {
    if (this._divHTML) {
      if (image !== undefined) {
        this._divHTML.style.backgroundImage = `url('${image}')`;
        this._image = image;
      }
    }
  }

  public static setImageWidth = (width: number) => {
    if (this._divHTML) {
      this._divHTML.style.backgroundSize = `${width}px`;
      this._zoomW = width;
      this._zoomH = this._zoomW * this._imgAspect;
    }
  }

  public static setImageXY = (x: number, y: number) => {
    if (this._divHTML) {
      const a = this._divHTML!.getBoundingClientRect();
      if (x > 0) x = 0;
      if (y > 0) y = 0;
      if (x + a.left + this._zoomW < a.right) x = -(this._zoomW - a.width);
      if (y + a.top + this._zoomH < a.bottom) y = -(this._zoomH - a.height);

      this._divHTML.style.backgroundPosition = `${x}px ${y}px`;

      this._imgX = x;
      this._imgY = y;
    }
  }

  public static setZoomFactor = (zoomFactor: number) => {
    this._zoomFactor = zoomFactor;
    if (this._zoomFactor < 1.0) this._zoomFactor = 1.0;
    if (this._zoomFactor > MAX_ZOOM_FAC) this._zoomFactor = MAX_ZOOM_FAC;

    const zHTML = document.getElementById("zoomFactor") as HTMLInputElement;
    if (zHTML) {
      zHTML.value = this._zoomFactor.toString(); //!!OA
    }
  }

  public static getZoomFactor = (): number => {
    return this._zoomFactor;
  }
}
